import { css } from 'styled-components';

import OpenSansLightEOT from '../assets/fonts/OpenSans/OpenSans-Light.eot';
import OpenSansLightTTF from '../assets/fonts/OpenSans/OpenSans-Light.ttf';
import OpenSansLightWOFF from '../assets/fonts/OpenSans/OpenSans-Light.woff';
import OpenSansLightWOFF2 from '../assets/fonts/OpenSans/OpenSans-Light.woff2';
import OpenSansLightSVG from '../assets/fonts/OpenSans/OpenSans-Light.svg';

import OpenSansBoldEOT from '../assets/fonts/OpenSans/OpenSans-Bold.eot';
import OpenSansBoldTTF from '../assets/fonts/OpenSans/OpenSans-Bold.ttf';
import OpenSansBoldWOFF from '../assets/fonts/OpenSans/OpenSans-Bold.woff';
import OpenSansBoldWOFF2 from '../assets/fonts/OpenSans/OpenSans-Bold.woff2';
import OpenSansBoldSVG from '../assets/fonts/OpenSans/OpenSans-Bold.svg';

import ComfortaaLightEOT from '../assets/fonts/Comfortaa/Comfortaa-Light.eot';
import ComfortaaLightTTF from '../assets/fonts/Comfortaa/Comfortaa-Light.ttf';
import ComfortaaLightWOFF from '../assets/fonts/Comfortaa/Comfortaa-Light.woff';
import ComfortaaLightWOFF2 from '../assets/fonts/Comfortaa/Comfortaa-Light.woff2';
import ComfortaaLightSVG from '../assets/fonts/Comfortaa/Comfortaa-Light.svg';

import ComfortaaBoldEOT from '../assets/fonts/Comfortaa/Comfortaa-Bold.eot';
import ComfortaaBoldTTF from '../assets/fonts/Comfortaa/Comfortaa-Bold.ttf';
import ComfortaaBoldWOFF from '../assets/fonts/Comfortaa/Comfortaa-Bold.woff';
import ComfortaaBoldWOFF2 from '../assets/fonts/Comfortaa/Comfortaa-Bold.woff2';
import ComfortaaBoldSVG from '../assets/fonts/Comfortaa/Comfortaa-Bold.svg';

import MulishLightEOT from '../assets/fonts/Mulish/Mulish-Light.eot';
import MulishLightTTF from '../assets/fonts/Mulish/Mulish-Light.ttf';
import MulishLightWOFF from '../assets/fonts/Mulish/Mulish-Light.woff';
import MulishLightWOFF2 from '../assets/fonts/Mulish/Mulish-Light.woff2';
import MulishLightSVG from '../assets/fonts/Mulish/Mulish-Light.svg';

import MulishRegularEOT from '../assets/fonts/Mulish/Mulish-Regular.eot';
import MulishRegularTTF from '../assets/fonts/Mulish/Mulish-Regular.ttf';
import MulishRegularWOFF from '../assets/fonts/Mulish/Mulish-Regular.woff';
import MulishRegularWOFF2 from '../assets/fonts/Mulish/Mulish-Regular.woff2';
import MulishRegularSVG from '../assets/fonts/Mulish/Mulish-Regular.svg';

import MulishBoldEOT from '../assets/fonts/Mulish/Mulish-Bold.eot';
import MulishBoldTTF from '../assets/fonts/Mulish/Mulish-Bold.ttf';
import MulishBoldWOFF from '../assets/fonts/Mulish/Mulish-Bold.woff';
import MulishBoldWOFF2 from '../assets/fonts/Mulish/Mulish-Bold.woff2';
import MulishBoldSVG from '../assets/fonts/Mulish/Mulish-Bold.svg';

import MulishBlackEOT from '../assets/fonts/Mulish/Mulish-Black.eot';
import MulishBlackTTF from '../assets/fonts/Mulish/Mulish-Black.ttf';
import MulishBlackWOFF from '../assets/fonts/Mulish/Mulish-Black.woff';
import MulishBlackWOFF2 from '../assets/fonts/Mulish/Mulish-Black.woff2';
import MulishBlackSVG from '../assets/fonts/Mulish/Mulish-Black.svg';

const fontsStyles = css`
 @font-face {
        font-family: 'Open Sans';
        src: url(${OpenSansLightEOT}) format('eot'),
        url(${OpenSansLightTTF}) format('ttf'),
        url(${OpenSansLightWOFF}) format('woff'),
        url(${OpenSansLightWOFF2}) format('woff2'),
        url(${OpenSansLightSVG}) format('svg');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'Open Sans';
        src: url(${OpenSansBoldEOT}) format('eot'),
        url(${OpenSansBoldTTF}) format('ttf'),
        url(${OpenSansBoldWOFF}) format('woff'),
        url(${OpenSansBoldWOFF2}) format('woff2'),
        url(${OpenSansBoldSVG}) format('svg');
        font-weight: 700;
        font-style: normal;
    }
    @font-face {
        font-family: 'Comfortaa';
        src: url(${ComfortaaLightEOT}) format('eot'),
        url(${ComfortaaLightTTF}) format('ttf'),
        url(${ComfortaaLightWOFF}) format('woff'),
        url(${ComfortaaLightWOFF2}) format('woff2'),
        url(${ComfortaaLightSVG}) format('svg');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'Comfortaa';
        src: url(${ComfortaaBoldEOT}) format('eot'),
        url(${ComfortaaBoldTTF}) format('ttf'),
        url(${ComfortaaBoldWOFF}) format('woff'),
        url(${ComfortaaBoldWOFF2}) format('woff2'),
        url(${ComfortaaBoldSVG}) format('svg');
        font-weight: 700;
        font-style: normal;
    }
    @font-face {
        font-family: 'Mulish';
        src: url(${MulishLightEOT}) format('eot'),
        url(${MulishLightTTF}) format('ttf'),
        url(${MulishLightWOFF}) format('woff'),
        url(${MulishLightWOFF2}) format('woff2'),
        url(${MulishLightSVG}) format('svg');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'Mulish';
        src: url(${MulishRegularEOT}) format('eot'),
        url(${MulishRegularTTF}) format('ttf'),
        url(${MulishRegularWOFF}) format('woff'),
        url(${MulishRegularWOFF2}) format('woff2'),
        url(${MulishRegularSVG}) format('svg');
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: 'Mulish';
        src: url(${MulishBoldEOT}) format('eot'),
        url(${MulishBoldTTF}) format('ttf'),
        url(${MulishBoldWOFF}) format('woff'),
        url(${MulishBoldWOFF2}) format('woff2'),
        url(${MulishBoldSVG}) format('svg');
        font-weight: 700;
        font-style: normal;
    }
    @font-face {
        font-family: 'Mulish';
        src: url(${MulishBlackEOT}) format('eot'),
        url(${MulishBlackTTF}) format('ttf'),
        url(${MulishBlackWOFF}) format('woff'),
        url(${MulishBlackWOFF2}) format('woff2'),
        url(${MulishBlackSVG}) format('svg');
        font-weight: 900;
        font-style: normal;
    }
`;

export default fontsStyles;